module.exports = __webpack_public_path__ + "img/title.74073beb.svg";